import {
  createErrorResource,
  createExternalResource,
  createLoadedResource,
  createLoadingResource,
} from '@next/arable-lib/external-resource';
import { createFeature, createReducer, on } from '@ngrx/store';

import {
  loadOrganicMatterBalance,
  loadOrganicMatterBalanceFailed,
  loadOrganicMatterBalanceSuccess,
  loadOrganicMatterBenchmark,
  loadOrganicMatterBenchmarkFailed,
  loadOrganicMatterBenchmarkSuccess,
} from './organic-matter-balance.actions';
import { cropYearChanged } from '../../../../store/actions';
import { OrganicMatterBalanceState } from '../organic-matter-balance.models';

export const initialOrganicMatterBalanceState: OrganicMatterBalanceState = {
  organicMatterReport: createExternalResource(),
  organicMatterBenchmark: createExternalResource(),
};

export const organicMatterBalanceFeature = createFeature({
  name: 'organicMatterBalance',
  reducer: createReducer(
    initialOrganicMatterBalanceState,

    on(cropYearChanged, () => initialOrganicMatterBalanceState),

    on(loadOrganicMatterBalance, (state) => ({
      ...state,
      organicMatterReport: createLoadingResource(),
    })),

    on(loadOrganicMatterBalanceSuccess, (state, { payload: { report } }) => ({
      ...state,
      organicMatterReport: createLoadedResource(report),
    })),

    on(loadOrganicMatterBalanceFailed, (state) => ({
      ...state,
      organicMatterReport: createErrorResource(),
    })),

    on(loadOrganicMatterBenchmark, (state) => ({
      ...state,
      organicMatterBenchmark: createLoadingResource(),
    })),

    on(loadOrganicMatterBenchmarkSuccess, (state, { payload: { benchmark } }) => ({
      ...state,
      organicMatterBenchmark: createLoadedResource(benchmark),
    })),

    on(loadOrganicMatterBenchmarkFailed, (state) => ({
      ...state,
      organicMatterBenchmark: createErrorResource(),
    })),
  ),
})

export const {
  selectOrganicMatterBalanceState,
} = organicMatterBalanceFeature;
